module.exports = __webpack_public_path__ + "img/dock_icon.cdea91c6.svg";